export function formatDuration(duration) {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration - (hours * 3600)) / 60);
  const seconds = Math.round(duration - (minutes * 60) - (hours * 3600));

  const result = [];

  if (hours) {
    result.push(`${hours}h`);
  }

  if (result.length || minutes) {
    result.push(`${minutes}m`);
  }

  result.push(`${seconds}s`);

  return result.join(' ');
}
